import Swiper, { Navigation, Autoplay, Pagination, FreeMode } from 'swiper';
import Page from '../page';

export default class Homepage2025Index extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();
        this._initAutoScroll();
        this._showPopupAfterDelay();
        this._addPopupCloseListener();
    }

    /**
     * Retrieve DOM elements
     */
    _retrieveDOM() {
        this.swiperContainer = document.querySelector('.chefs__slider');
        this.nextButton = document.querySelector('.swiper-button-next');
        this.prevButton = document.querySelector('.swiper-button-prev');
        this.chefsPagination = document.querySelector('.chefs .swiper-pagination');

        this.sliderTopContainer = document.querySelector('.culinary__slider-top');
        this.sliderBottomContainer = document.querySelector('.culinary__slider-bottom');

        this.newsSliderContainer = document.querySelector('.news__slider');
        this.newsNextButton = document.querySelector('.news .swiper-button-next');
        this.newsPrevButton = document.querySelector('.news .swiper-button-prev');
        this.newsPagination = document.querySelector('.news .swiper-pagination');

        this.partnersContainer = document.querySelector('.partners__container');
    }

    _initTls() {
        if (this.swiperContainer) {
            this._initSwiper();
        }

        if (this.sliderTopContainer) {
            this._initSliderTop();
        }
        if (this.sliderBottomContainer) {
            this._initSliderBottom();
        }

        if (this.newsSliderContainer) {
            this._initNewsSlider();
        }
    }

    _initSwiper() {
        if (this.swiperContainer) {
            this.swiper = new Swiper(this.swiperContainer, {
                modules: [Navigation, Pagination],
                loop: true,
                centeredSlides: true,
                slidesPerView: 1.25,
                spaceBetween: 20,
                navigation: {
                    nextEl: this.nextButton,
                    prevEl: this.prevButton,
                },
                pagination: {
                    el: this.chefsPagination,
                    type: 'progressbar',
                },
                slideToClickedSlide: true,
                breakpoints: {
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 20,
                    },
                },
            });
        }
    }

    _initSliderTop() {
        this.sliderTop = new Swiper(this.sliderTopContainer, {
            modules: [Autoplay, FreeMode],
            loop: true,
            slidesPerView: 2,
            spaceBetween: 14,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            speed: 4000,
            freeMode: true,
            breakpoints: {
                768: {
                    slidesPerView: 6,
                    spaceBetween: 14,
                },
            },
        });
    }

    _initSliderBottom() {
        this.sliderBottom = new Swiper(this.sliderBottomContainer, {
            modules: [Autoplay, FreeMode],
            loop: true,
            slidesPerView: 2,
            spaceBetween: 14,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: true,
            },
            speed: 4000,
            freeMode: true,
            breakpoints: {
                768: {
                    slidesPerView: 6,
                    spaceBetween: 14,
                },
            },
        });
    }

    _initNewsSlider() {
        this.newsSlider = new Swiper(this.newsSliderContainer, {
            modules: [Navigation, Pagination],
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: this.newsNextButton,
                prevEl: this.newsPrevButton,
            },
            pagination: {
                el: this.newsPagination,
                type: 'progressbar',
            },
        });
    }

    _initAutoScroll() {
        if (!this.partnersContainer) return;

        const container = this.partnersContainer;
        const scrollSpeed = 1;

        const content = container.innerHTML;
        container.innerHTML += content;

        let scrollPosition = 0;

        const autoScroll = () => {
            if (scrollPosition >= container.scrollWidth / 2) {
                scrollPosition = 0;
            }
            scrollPosition += scrollSpeed;
            container.scrollLeft = scrollPosition;
            requestAnimationFrame(autoScroll);
        };

        autoScroll();
    }

    _showPopupAfterDelay() {
        const popup = document.querySelector('.header__popup');
        if (!popup) return;

        if (document.cookie.split('; ').includes('popupClosed=true')) {
            return;
        }

        setTimeout(() => {
            popup.classList.add('visible');
        }, 2000);
    }

    _addPopupCloseListener() {
        const popup = document.querySelector('.header__popup');
        const closeButton = document.querySelector('.header__popup__close');
        if (!popup || !closeButton) return;

        closeButton.addEventListener('click', () => {
            popup.classList.remove('visible');
            document.cookie = "popupClosed=true; path=/; max-age=86400";
        });
    }
}




// WEBPACK FOOTER //
// ./src/js/pages/homepage-2025/homepage-2025-index.js